let idCount = 0;
let timerWorker: Worker;

function getTimerWorker() {
  if (!timerWorker) {
    timerWorker = new Worker('/js/timerWorker.js');
  }
  return timerWorker;
}

export const setWorkerInterval = (callback: () => void, delay: number | null) => {
  const id = ++idCount;
  const timerWorker = getTimerWorker();
  const messageListener = (e: MessageEvent) => {
    if (e.data.type === 'intervalTick' && e.data.payload.id === id) {
      callback();
    }
  };
  timerWorker.postMessage({payload: {delay, id}, type: 'setInterval'});
  timerWorker.addEventListener('message', messageListener);
  return () => {
    timerWorker.postMessage({payload: {id}, type: 'clearInterval'});
    timerWorker.removeEventListener('message', messageListener);
  };
};

export const setWorkerTimeout = (callback: () => void, delay: number | null) => {
  const id = ++idCount;
  const timerWorker = getTimerWorker();
  const messageListener = (e: MessageEvent) => {
    if (e.data.type === 'timeoutTick' && e.data.payload.id === id) {
      callback();
    }
  };
  timerWorker.postMessage({payload: {delay, id}, type: 'setTimeout'});
  timerWorker.addEventListener('message', messageListener);
  return () => {
    timerWorker.postMessage({payload: {id}, type: 'clearTimeout'});
    timerWorker.removeEventListener('message', messageListener);
  };
};
